<template>
  <article class="basic">
    <ul class="tab-service-detail borT-none">
      <li v-for="item in tabList" :class="{on: item.isActive}" :key="item.key" @click.stop="tabHandler(item.key)">
        <a href="javascript:void(0);" :class="{'not_completed': !item.completed}">{{item.title}}</a>
      </li>
    </ul>
    <!-- 基本信息 -->
    <basic-info
      ref="basic"
      v-if="basic"
      :source="source"
      :id="id"
      :basic-info="basicInfo"
      :basic-info-save.sync="basicInfoSave"
      @on-after-save="afterSaveHandler"
      @on-search-vin="searchVin"
    ></basic-info>
    <!-- 配置信息 -->
    <config-info
      ref="config"
      v-if="config"
      :source="source"
      :id="id"
      :config-info="configInfo"
      :config-info-from-jzg="configInfoFromJzg"
      :procedure-info="procedureInfo"
      :procedure-is-ready.sync="procedureIsReady"
      :config-is-ready.sync="configIsReady"
      @on-after-save="afterSaveHandler"
    ></config-info>
    <!-- 手续信息 -->
    <procedure-info
      ref="procedure"
      v-if="procedure"
      :source="source"
      :id="id"
      :config-info="configInfo"
      :procedure-info="procedureInfo"
      :config-is-ready.sync="configIsReady"
      :procedure-is-ready.sync="procedureIsReady"
      @on-after-save="afterSaveHandler"
    ></procedure-info>
    <!-- 评估简述 -->
    <remark-info
      ref="remark"
      v-if="remark"
      :source="source"
      :id="id"
      :remark-info.sync="remarkInfo"
      @on-after-save="afterSaveHandler"
    ></remark-info>
  </article>
</template>

<script>
import cache from '../../../common/cache'
import BasicInfo from './BasicInfo'
import ConfigInfo from './ConfigInfo'
import ProcedureInfo from './ProcedureInfo'
import RemarkInfo from './RemarkInfo'
import { detail } from './restConfig'

export default {
  components: {
    BasicInfo,
    ConfigInfo,
    ProcedureInfo,
    RemarkInfo
  },
  data() {
    return {
      id: '', // 车辆id
      source: '',
      curTab: 'basic', // 当前展示的tab
      basicInfo: { // 基本信息
        vin: '', // 车架号
        car_model_id: '', // 车型id
        car_model_name: '', // 车型描述
        mileage: '', // 里程
        color_id: '', // 颜色id
        is_color_changed: false, // 车身颜色是否改变（Boolen）
        production_date: '', // 车辆出厂时间
        license_issued_on: '', // 上牌时间
        transfer_count: '', // 过户次数
        last_transfer_date: '', // 最后过户时间
        belonged_province: '北京市', // 车辆归属地-省份
        belonged_province_code: '110000', // 车辆归属地-省份编码
        belonged_city: '北京市市辖区', // 车辆归属地-城市
        belonged_city_code: '110100', // 车辆归属地-城市编码
        located_province: '北京市', // 车辆所在地-省份
        located_province_code: '110000', // 车辆所在地-省份编码
        located_city: '北京市市辖区', // 车辆所在地-城市
        located_city_code: '110100', // 车辆所在地-城市编码
        plate_number: '', // 车牌号
        is_refitted: false, // 是否改装 (布尔值)
        car_character: '', // 车辆性质
        car_character_name: '', // 车辆性质名称
        usage_character: '', // 使用性质
        usage_character_name: '', // 使用性质名称
        emission_standard: '', // 排放标准
        emission_standard_name: '' // 排放标准名称
      },
      configInfo: [ // 配置信息
        {
          'group_name': 'basic',
          'name': '基本参数',
          'params': [
            {
              'name': '车门数(个)',
              'external_name': 'Body_Doors',
              'value': null
            },
            {
              'name': '座位数(个)',
              'external_name': 'Perf_SeatNum',
              'value': null
            },
            {
              'name': '排量(L)',
              'external_name': 'Engine_ExhaustForFloat',
              'value': null
            },
            {
              'name': '燃料类型',
              'external_name': 'Oil_FuelType',
              'value': null
            },
            {
              'name': '挡位个数(个)',
              'external_name': 'UnderPan_ForwardGearNum',
              'value': null
            },
            {
              'name': '变速箱类型',
              'external_name': 'UnderPan_TransmissionType',
              'value': null
            },
            {
              'name': '驱动方式',
              'external_name': 'Perf_DriveType',
              'value': null
            }
          ]
        },

        {
          'group_name': 'security',
          'name': '主/被动安全设备',
          'params': [
            {
              'name': '驾驶位安全气囊',
              'external_name': 'Safe_DriverGasBag',
              'value': null
            },
            {
              'name': '副驾驶位安全气囊',
              'external_name': 'Safe_SubDriverGasBag',
              'value': null
            },
            {
              'name': '前排侧安全气囊',
              'external_name': 'Safe_FsadGasbag',
              'value': null
            },
            {
              'name': '后排侧安全气囊',
              'external_name': 'Safe_BsadGasbag',
              'value': null
            },
            {
              'name': '前排头部气囊(气帘)',
              'external_name': 'Safe_FheadGasbag',
              'value': null
            },
            {
              'name': '膝部气囊',
              'external_name': 'Safe_KneeGasBag',
              'value': null
            },
            {
              'name': '安全带气囊',
              'external_name': 'InStat_BeltBag',
              'value': null
            },
            {
              'name': '胎压监测装置',
              'external_name': 'UnderPan_TyrePressureWatcher',
              'value': null
            },
            {
              'name': '刹车防抱死(ABS)',
              'external_name': 'Safe_ABS',
              'value': null
            },
            {
              'name': '盲点检测/并线辅助',
              'external_name': 'InStat_blindspotdetection',
              'value': null
            },
            {
              'name': '夜视系统',
              'external_name': 'InStat_NightVisionSystem',
              'value': null
            }
          ]
        },

        {
          'group_name': 'accessory',
          'name': '辅助/操控配置',
          'params': [
            {
              'name': '泊车雷达(车前)',
              'external_name': 'UnderPan_PRadar',
              'value': null
            },
            {
              'name': '倒车雷达(车后)',
              'external_name': 'UnderPan_RRadar',
              'value': null
            },
            {
              'name': '倒车影像',
              'external_name': 'UnderPan_RImage',
              'value': null
            },
            {
              'name': '全景摄像头',
              'external_name': 'InStat_PanoramicCamera',
              'value': null
            },
            {
              'name': '定速巡航',
              'external_name': 'InStat_SpeedCruise',
              'value': null
            },
            {
              'name': '自适应巡航',
              'external_name': 'InStat_Automaticcruise',
              'value': null
            },
            {
              'name': '自动泊车入位',
              'external_name': 'InStat_AutoParking',
              'value': null
            },
            {
              'name': '上坡辅助',
              'external_name': 'InStat_UphillAuxiliary',
              'value': null
            },
            {
              'name': '自动驻车',
              'external_name': 'InStat_AutoPark',
              'value': null
            },
            {
              'name': '陡坡缓降',
              'external_name': 'InStat_HDC',
              'value': null
            },
            {
              'name': '遥控驾驶',
              'external_name': 'Safe_Remotedriving',
              'value': null
            }
          ]
        },

        {
          'group_name': 'external',
          'name': '外部/防盗配置',
          'params': [
            {
              'name': '天窗型式',
              'external_name': 'Body_Louver',
              'value': null
            },
            {
              'name': '运动外观套件',
              'external_name': 'OutStat_SportsAppearanceKit',
              'value': null
            },
            {
              'name': '铝合金轮圈',
              'external_name': 'Aluminum_alloy_wheels # 没有标明',
              'value': null
            },
            {
              'name': '感应行李厢',
              'external_name': 'Induction_trunk',
              'value': null
            },
            {
              'name': '车顶行李箱架',
              'external_name': 'OutStat_TopSnelf',
              'value': null
            },
            {
              'name': '无钥匙启动系统',
              'external_name': 'InStat_AIgnitionSys',
              'value': null
            },
            {
              'name': '无钥匙进入系统',
              'external_name': 'nokey_into',
              'value': null
            },
            {
              'name': '遥控启动',
              'external_name': 'InStat_RemoteStart',
              'value': null
            },
            {
              'name': '后导流尾翼',
              'external_name': 'OutStat_InductEmpennage',
              'value': null
            }
          ]
        },

        {
          'group_name': 'internal',
          'name': '内部配置',
          'params': [
            {
              'name': '多功能方向盘',
              'external_name': 'InStat_MultiFuncSteer',
              'value': null
            },
            {
              'name': '换挡拨片',
              'external_name': 'InStat_SteerEtc',
              'value': null
            },
            {
              'name': '方向盘加热',
              'external_name': 'Steering_Wheel_hot',
              'value': null
            },
            {
              'name': '方向盘记忆设置',
              'external_name': 'InStat_SteerMomery',
              'value': null
            },
            {
              'name': '方向盘表面材料',
              'external_name': 'InStat_SteerMaterial',
              'value': null
            },
            {
              'name': 'HUD抬头数字显示',
              'external_name': 'InStat_Hud',
              'value': null
            }
          ]
        },

        {
          'group_name': 'seat',
          'name': '座椅配置',
          'params': [
            {
              'name': '座椅材料',
              'external_name': 'InStat_SeatMaterial',
              'value': null
            },
            {
              'name': '运动座椅',
              'external_name': 'InStat_SportSeat',
              'value': null
            },
            {
              'name': '驾驶座腰部支撑调节',
              'external_name': 'InStat_DSeatProp',
              'value': null
            },
            {
              'name': '驾驶座肩部支撑调节',
              'external_name': 'InStat_AdjustableShoulderSupport',
              'value': null
            },
            {
              'name': '驾驶座座椅调节方式',
              'external_name': 'InStat_DSeatTuneType',
              'value': null
            },
            {
              'name': '副驾驶座椅调节方式',
              'external_name': 'InStat_DASeatTuneType',
              'value': null
            },
            {
              'name': '电动座椅记忆',
              'external_name': 'InStat_ElectricSeatMemory',
              'value': null
            },
            {
              'name': '前排座椅加热',
              'external_name': 'Heated_front_seats',
              'value': null
            },
            {
              'name': '后排座椅加热',
              'external_name': 'Heated_rear_seats',
              'value': null
            },
            {
              'name': '前排座椅通风',
              'external_name': 'The_front_seat_ventilation',
              'value': null
            },
            {
              'name': '后排座椅通风',
              'external_name': 'Rear_seat_ventilation',
              'value': null
            },
            {
              'name': '座椅按摩功能',
              'external_name': 'InStat_SeatKnead',
              'value': null
            },
            {
              'name': '第三排座椅',
              'external_name': 'InStat_3rdRowSeats',
              'value': null
            }
          ]
        },

        {
          'group_name': 'multimedia',
          'name': '多媒体配置',
          'params': [
            {
              'name': 'GPS导航系统',
              'external_name': 'InStat_GPS',
              'value': null
            },
            {
              'name': '中控台液晶屏',
              'external_name': 'InStat_CCEscreen',
              'value': null
            },
            {
              'name': '后排液晶屏',
              'external_name': 'InStat_BEscreen',
              'value': null
            },
            {
              'name': '蓝牙系统',
              'external_name': 'InStat_Bluetooth',
              'value': null
            },
            {
              'name': '无线上网功能',
              'external_name': 'InStat_WireLink',
              'value': null
            },
            {
              'name': '车载电视',
              'external_name': 'InStat_Video',
              'value': null
            },
            {
              'name': 'CD',
              'external_name': 'InStat_CDPlayer',
              'value': null
            },
            {
              'name': 'DVD',
              'external_name': 'InStat_DVDPlayer',
              'value': null
            }
          ]
        },

        {
          'group_name': 'light',
          'name': '灯光配置',
          'params': [
            {
              'name': '日间行车灯',
              'external_name': 'OutStat_DaytimeRunningLights',
              'value': null
            },
            {
              'name': '前大灯自动开闭',
              'external_name': 'OutStat_FLightClose',
              'value': null
            },
            {
              'name': '前雾灯',
              'external_name': 'OutStat_FfogLamp',
              'value': null
            },
            {
              'name': '前大灯自动清洗功能',
              'external_name': 'OutStat_FLightAutoClean',
              'value': null
            },
            {
              'name': '前大灯随动转向',
              'external_name': 'OutStat_FLightSteer',
              'value': null
            },
            {
              'name': '前大灯类型',
              'external_name': 'OutStat_FrontLightType',
              'value': null
            }
          ]
        },

        {
          'group_name': 'glass',
          'name': '玻璃/后视镜',
          'params': [
            {
              'name': '前电动车窗',
              'external_name': 'The_front_power_window',
              'value': null
            },
            {
              'name': '后电动车窗',
              'external_name': 'After_the_electric_window',
              'value': null
            },
            {
              'name': '外后视镜电动调节',
              'external_name': 'OutStat_ReMirrorElecTune',
              'value': null
            },
            {
              'name': '外后视镜加热功能',
              'external_name': 'OutStat_ReMirrorHot',
              'value': null
            },
            {
              'name': '内后视镜防眩目功能',
              'external_name': 'OutStat_ReMirrorDazzle',
              'value': null
            },
            {
              'name': '外后视镜电动折叠功能',
              'external_name': 'OutStat_ReMirrorFold',
              'value': null
            },
            {
              'name': '外后视镜记忆功能',
              'external_name': 'OutStat_ReMirrormemory',
              'value': null
            },
            {
              'name': '后窗遮阳帘',
              'external_name': 'OutStat_BackCurtain',
              'value': null
            },
            {
              'name': '后排侧遮阳帘',
              'external_name': 'OutStat_SecondRowCurtain',
              'value': null
            },
            {
              'name': '遮阳板化妆镜',
              'external_name': 'InStat_FaceMirror',
              'value': null
            },
            {
              'name': '后雨刷器',
              'external_name': 'OutStat_BBrushSensor',
              'value': null
            }
          ]
        },

        {
          'group_name': 'refrigeration',
          'name': '空调/冰箱',
          'params': [
            {
              'name': '空调控制方式',
              'external_name': 'InStat_AirCType',
              'value': null
            },
            {
              'name': '后排独立空调',
              'external_name': 'InStat_BAirCSystem',
              'value': null
            },
            {
              'name': '温度分区控制',
              'external_name': 'InStat_TemperSubCount',
              'value': null
            },
            {
              'name': '车载冰箱',
              'external_name': 'InStat_carFridge',
              'value': null
            }
          ]
        }
      ],
      procedureInfo: { // 手续信息
        transferRequest: '', // 过户要求(天数）
        purchaseTax: '1', // 购置税
        drivingLicense: '有', // 行驶证
        registration: '有', // 登记证
        annualDue: '', // 年检到期日
        strongInsurance: '', // 强险到期日
        commercialInsurance: '', // 商险到期日
        carInvoice: '有', // 新车发票
        carWarranty: '过保', // 新车质保
        key: '2', // 钥匙
        maintenanceManual: '有', // 保养手册
        instructions: '有', // 说明书
        unHandleIllegal: '无', // 未处理违章
        // transferTimes: '',       // 过户次数
        transferTickets: '有', // 过户票
        newPlace: '1', // 迁往何处
        transferFee: '1', // 过户费
        freight: '1', // 运费
        mentionFee: '1', // 提档费
        proceduresSpend: '1' // 手续补办费用
      },
      configInfoFromJzg: [], // 配置信息来自精真估
      remarkInfo: '',
      basic: false,
      config: false,
      procedure: false,
      remark: false,
      // tab列表, is_complete 是否进行过保存
      tabList: [
        {
          title: '基本信息',
          key: 'basic',
          isActive: true,
          completed: false
        }, {
          title: '配置信息',
          key: 'config',
          isActive: false,
          completed: false
        }, {
          title: '手续信息',
          key: 'procedure',
          isActive: false,
          completed: false
        }, {
          title: '评估简述',
          key: 'remark',
          isActive: false,
          completed: false
        }
      ],
      basicInfoSave: false, // 是否是第一次评估车辆信息
      configIsReady: false,
      procedureIsReady: false
    }
  },
  created() {
    // 保存页面来源, 会影响保存需要的数据接口
    this.source = this.$route.params.source
    // 车辆ID
    this.id = this.$route.params.id
    // 线索id
    // this.ticketId = this.$route.query.ticketId || ''
    this.ticketId = cache.getSessionData('CAR_INFO_TICKET_ID') || ''
    this.switchLoading({ status: true, text: '加载中...' })
    if (this.id) {
      let url = detail.getClueDetail[this.source](this.id)
      this.$rest.carInfo.query(null, url).then(res => { // 重新评估
        if (res.code === 0) {
          if (res.data && res.data.car_info) {
            let data = res.data.car_info
            Object.keys(data).forEach(key => {
              // 获取基本信息
              if (key !== 'info' && key !== 'note' && key !== 'id') {
                if (data[key] === null) {
                  this.basicInfo[key] = ''
                } else {
                  this.basicInfo[key] = data[key]
                  this.basicInfoSave = true
                }
              }
              // 备注信息
              if (key === 'note') {
                if (data[key]) {
                  this.tabList[3].completed = true
                }
                this.$store.dispatch('UPDATE_CAR_REMARK_INFO', data[key])
              }
              // info
              if (key === 'info') {
                // 配置信息
                this.configInfo = data[key].config || this.configInfo
                this.configIsReady = data[key] ? data[key].config_is_ready : false
                // 手续信息
                this.procedureInfo = data[key].procedure || this.procedureInfo
                this.procedureIsReady = data[key] ? data[key].procedure_is_ready : false
              }
            })
            this.switchLoading({ status: false })
            this.basic = true // 显示基本信息
            // 保存基本信息
            this.$store.dispatch('UPDATE_CAR_BASIC_INFO', this.basicInfo)
          } else if (this.ticketId) { // 第一次线索评估
            // this.isNewInfo = true
            this.$rest.usedCar.getTicket(null, this.ticketId).then(res => {
              if (res.code === 0) {
                let fields = [
                  {
                    origin: 'jzg_car_model_id',
                    cur: 'car_model_id'
                  },
                  'car_model_name',
                  'plate_number',
                  'license_issued_on',
                  'vin',
                  'mileage',
                  'transfer_count',
                  // 'channel',
                  {
                    origin: 'jzg_color_id',
                    cur: 'color_id'
                  },
                  {
                    origin: 'vehicle_province',
                    cur: 'belonged_province'
                  },
                  {
                    origin: 'vehicle_province_code',
                    cur: 'belonged_province_code'
                  },
                  {
                    origin: 'vehicle_city',
                    cur: 'belonged_city'
                  },
                  {
                    origin: 'vehicle_city_code',
                    cur: 'belonged_city_code'
                  },
                  {
                    origin: 'vehicle_province',
                    cur: 'located_province'
                  },
                  {
                    origin: 'vehicle_province_code',
                    cur: 'located_province_code'
                  },
                  {
                    origin: 'vehicle_city',
                    cur: 'located_city'
                  },
                  {
                    origin: 'vehicle_city_code',
                    cur: 'located_city_code'
                  }]
                fields.forEach(val => {
                  if (typeof val === 'object') {
                    this.basicInfo[val.cur] = res.data[val.origin]
                  } else {
                    this.basicInfo[val] = res.data[val]
                  }
                })
                this.switchLoading({ status: false })
                this.basic = true // 显示基本信息
                // 保存基本信息
                this.$store.dispatch('UPDATE_CAR_BASIC_INFO', this.basicInfo)
              } else {
                this.showToast(res.message)
              }
            })
          } else { // 第一次新增车辆评估
            this.switchLoading({ status: false })
            this.basic = true // 显示基本信息
            // 保存基本信息
            this.$store.dispatch('UPDATE_CAR_BASIC_INFO', this.basicInfo)
          }
        } else {
          this.showToast(res.message)
        }
      })
    } else {
      this.showToast('没有id~')
    }
  },
  watch: {
    'basicInfoSave'(val) {
      this.tabList[0].completed = val
    },
    'configIsReady' (val) {
      this.tabList[1].completed = val
    },
    'procedureIsReady' (val) {
      this.tabList[2].completed = val
    },
    isRemark(val) {
      this.tabList[3].completed = val
    }
  },
  methods: {
    // 点击tab按钮后触发的事件处理器
    tabHandler (key) {
      if (this.curTab && this.$refs[this.curTab]) this.$refs[this.curTab].goToAnother(key)
    },
    // 保存后触发的事件处理器
    afterSaveHandler (key) {
      this.tabList.forEach((item, index) => {
        if (key === item.key) {
          this.curTab = key
          item.isActive = this[item.key] = true
        } else {
          item.isActive = this[item.key] = false
        }
      })
    },
    searchVin(carModelId) {
      // 获取配置信息
      this.$rest.carInfo.query(null, `car_model/${carModelId}/configurations`).then(res => {
        if (res.code === 0) {
          this.configInfoFromJzg = res.data.configurations
        } else {
          this.showToast(res.message)
        }
      })
    }
  },
  computed: {
    isRemark() {
      // 评估简述是否展示小红点， 1、评估过线索，但是该线索没有点击过评估简述，或者评估简述内容为空， 2、第一次评估线索、
      if (this.$store.state.usedCar.note) {
        return true
      }
      return false
    }
  }
}
</script>
<style lang="less">
  @import "../../../stylesheets/modules/manage/input.less";
  .basic .tab-service-detail, .config .tab-service-detail li a {
    padding: 0;
  }
  .borT-none{
    .not_completed {
      position: relative;
      &:after{
        content: "";
        position: absolute;
        top: 15/@w2;
        right: 0;
        width: 12/@w2;
        height: 12/@w2;
        background-color: #fb3f3f;
        .radius(50%);
      }
    }
  }
</style>
